import React from "react";
import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";

export function LaunchCard({ eyebrow, title, children, testId, aside }) {
  return (
    <section className="border p-6" style={{ borderColor: "var(--border)", background: "var(--surface)" }} data-testid={testId}>
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div>
          {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
          <h3 className="font-heading font-bold text-xl" style={{ color: "var(--ink)" }}>{title}</h3>
        </div>
        {aside}
      </div>
      {children}
    </section>
  );
}

const BADGES = {
  pass: { label: "Pass", icon: CheckCircle2, color: "#0F5132", bg: "#D1E7DD" },
  warn: { label: "Warning", icon: AlertTriangle, color: "#664D03", bg: "#FFF3CD" },
  fail: { label: "Not ready", icon: XCircle, color: "#842029", bg: "#F8D7DA" },
};

export function StatusBadge({ status, label, testId }) {
  const badge = BADGES[status] || BADGES.warn;
  const Icon = badge.icon;
  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap" style={{ color: badge.color, background: badge.bg }} data-testid={testId}>
      <Icon size={12} /> {label || badge.label}
    </span>
  );
}

export const inputClass = "w-full border px-3 py-2 text-sm outline-none";
export const inputStyle = { borderColor: "var(--border-strong)", background: "var(--bg)" };

/** datetime-local value (browser time) for an ISO string. */
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
